import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage, Field, Formik, Form as FormikForm } from 'formik';
import AsyncSelect from 'react-select/async';
import { Spinner } from 'react-bootstrap';
import * as Yup from 'yup';
import axiosWrapper from '../../../utils/api';
import { usePaymentContext } from '../paymentProcessor';
import './ZoneForm.scss';
import buttonArrowRight from '@icons/buttonArrowRight.svg';
import { components } from 'react-select';
import GroupAdminAuthLayout from '../../../layout/GroupAdminLayout/Auth/GroupAdminAuthLayout';
import { useMediaQuery } from 'react-responsive';
import { pageActivator } from '../verifyProcess';

const ZoneForm = ({ zoneID }) => {
    const navigate = useNavigate();
    const [locationData, setLocationData] = useState([]);
    const [zoneOptions, setZoneOptions] = useState([]);
    const [initialValues, setInitialValues] = useState({ zone: '' });
    const { paymentProcessor, setPaymentProcessor } = usePaymentContext();

    useEffect(() => {
        getLocations();
    }, []);

    useEffect(() => {
        // Once locationData is fetched, update zoneOptions and initialValues
        const options = locationData?.map((item) => ({
            value: item?.zone,
            label: item?.zone,
            city: item?.city
        }));
        setZoneOptions(options);

        const preSelectedZone = options?.find((option) => option?.value === zoneID) || null;
        setInitialValues({ zone: preSelectedZone?.value || paymentProcessor?.zone?.value || '' });
    }, [locationData, zoneID, paymentProcessor]);

    // Fetch locations
    const getLocations = async () => {
        try {
            const data = await axiosWrapper(
                'get',
                `${import.meta.env.VITE_API_URL}/api/locations/user/all/locations`,
                {},
                null
            );
            const activeLocations = data?.data?.filter((item) => item.status === true);
            setLocationData(activeLocations);
        } catch (error) {
            // Handle error
        }
    };

    const validationSchema = Yup.object().shape({
        zone: Yup.string().required('Zone is required')
    });
    const isMobile = useMediaQuery({ query: '(max-width: 925px)' });
    const handleSubmitZone = async (values, { setSubmitting }) => {
        try {
            const selectedZoneData = locationData.find((loc) => loc.zone === values.zone);
            setPaymentProcessor({
                ...paymentProcessor,
                isSaleTaxRequired: selectedZoneData?.isSaleTaxRequired || false,
                zone: {
                    ...paymentProcessor.zone,
                    status: false,
                    value: values.zone || selectedZoneData?.zone || zoneID,
                    ballParcZoneId: selectedZoneData?.ballParcZoneId,
                    city: selectedZoneData?.city || '',
                    locationFamilyType: selectedZoneData?.locationFamilyType
                },
                duration: {
                    ...paymentProcessor.duration,
                    status: selectedZoneData?.locationFamilyType !== 'multiFamily',
                    byHour: selectedZoneData?.locationFamilyType === 'multiFamily',
                    value: {
                        hours: 0,
                        minutes: 0,
                        days: 0
                    }
                }
            });
            if (selectedZoneData?.locationFamilyType === 'multiFamily' && selectedZoneData?.isAccessCodeRequired) {
                navigate(`/multifamily/${selectedZoneData?._id}?step=${selectedZoneData?.rateSelection?.displayedAs}`);
                return;
            }
            // if (selectedZoneData?.locationFamilyType === 'multiFamily' && !selectedZoneData?.isAccessCodeRequired) {
            //     navigate(`/multifamily/${selectedZoneData?._id}?step=${selectedZoneData?.rateSelection?.displayedAs}`);
            //     return;
            // }

            try {
                const response = await axiosWrapper(
                    'get',
                    `${import.meta.env.VITE_API_URL}/api/locations/get-location/${values.zone}`,
                    {}
                );
                // const response = await axiosWrapper(
                //     'get',
                //     `${import.meta.env.VITE_API_URL}/api/locations/get/single/${selectedZoneData?._id}`,
                //     {}
                // );
                navigate('/duration', {
                    state: { zone: response ? response : selectedZoneData }
                });
                setSubmitting(false);
            } catch (error) {
                // Handle error
            }
        } catch (error) {
            setSubmitting(false);
        }
    };

    const customSingleValue = ({ children, ...props }) => (
        <components.SingleValue {...props}>
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                <span>{props.data?.value}</span>
                {props.data?.city && <span style={{ marginLeft: '8px', color: '#888' }}>- {props.data?.city}</span>}
            </div>
        </components.SingleValue>
    );

    const filterOptions = (inputValue) => {
        return zoneOptions?.filter((option) => option?.label?.toLowerCase().includes(inputValue?.toLowerCase()));
    };

    const loadOptions = (inputValue, callback) => {
        setTimeout(() => {
            callback(filterOptions(inputValue));
        }, 1000);
    };

    useEffect(() => {
        pageActivator('zone', paymentProcessor, setPaymentProcessor);
    }, [setPaymentProcessor]);
    const ConfirmZone = (isMobile = false) => {
        return (
            <>
                {/* <img className="parking-image" src={parkingImage} alt="" /> */}
                <div className="main-width-zone">
                    <Formik
                        enableReinitialize
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmitZone}
                        validateOnChange={true}
                    >
                        {({ isSubmitting, setFieldValue, values }) => (
                            <FormikForm className="information-form">
                                <div className="fields-row">
                                    <div className="field-container mt-3">
                                        <span className="select-zone my-4">Confirm Zone</span>
                                        <span className="second-text mb-3">
                                            You can find the zone # on the zone where you have parked.
                                        </span>
                                        <label className="zone-number">Enter the Zone #</label>

                                        <Field name="zone">
                                            {() => (
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={loadOptions}
                                                    options={zoneOptions}
                                                    className="zone-field"
                                                    defaultOptions={false}
                                                    value={zoneOptions?.find(
                                                        (option) => option?.value === values?.zone
                                                    )}
                                                    onChange={(option) => {
                                                        setFieldValue('zone', option.value);
                                                    }}
                                                    components={{ SingleValue: customSingleValue }}
                                                    placeholder="Zone"
                                                    noOptionsMessage={() => null}
                                                    inputProps={{
                                                        inputMode: 'numeric' // Suggest numeric keypad
                                                    }}
                                                />
                                            )}
                                        </Field>

                                        <ErrorMessage name="zone" component="span" className="validation-error" />
                                    </div>
                                </div>
                                <div className="buttons-row zone-button">
                                    <button type="submit" className="next-btn w-100">
                                        {isSubmitting ? <Spinner animation="border" size="sm" /> : 'Next'}
                                        <img src={buttonArrowRight} alt="" className="zone-img" />
                                    </button>
                                </div>
                            </FormikForm>
                        )}
                    </Formik>
                </div>
            </>
        );
    };
    return (
        <>
            {isMobile ? (
                ConfirmZone(true)
            ) : (
                <GroupAdminAuthLayout
                    props={() => ConfirmZone(false)}
                    pageTitle="Confirm Zone"
                    screenTitle="Confirm Zone"
                />
            )}
        </>
    );
};

export default ZoneForm;
